import { Box, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import {
  getLocalStorage,
  setLocalStorage,
  showWebScreen,
} from "utils/generalUtils";
import useViewport from "Hooks/useViewport";
import Header from "Components/Common/Header";
import SideDrawer from "Components/Common/SideDrawer";
import HeaderMob from "Components/Common/HeaderWithSideBarMob";
import WelcomeDialog from "Components/Common/WelcomeDialog";
import TimerLogoutDailog from "./Auth/TimerLogoutDailog";

const useStyle = makeStyles((theme) => ({
  rsContainerWrapperRoot: {
    minHeight: "100vh",
    overflowX: "hidden",
    overflowY: "hidden",
    transition: "none !important",
  },
  rsContainerWrapperBody: {
    flex: "0 0 calc(100% - 60px)",
    maxWidth: "calc(89% - 52px)",
    // marginLeft: "auto",
    marginLeft: "260px",
    // padding: "0px 20px",
    height: "calc(100vh - 85px)",
    // minHeight: "100vh",
    overflowX: "hidden",
    overflowY: "auto",
  },
  rsContainerWrapperBodyPin: {
    flex: "0 0 calc(100% - 60px)",
    maxWidth: "calc(100% - 60px)",
    marginLeft: "auto",
    // padding: "0px 20px",
    // height: "calc(100vh - 101px)",
    height: "calc(100vh - 85px)",
    overflowX: "hidden",
    overflowY: "auto",
  },
  rsMainTitle: {
    marginTop: "5px !important",
    marginBottom: "5px !important",
    color: "black !important",
    fontSize: "20px !important",
    paddingLeft: "21px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px !important",
    },
    "& .RsTitle": {
      color: "black !important",
      fontSize: "22px !important",
      fontWeight: "600 !important",
    },
    "& .RsSubTitle": {
      color: "#5A6872 !important",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      marginTop: "2px",
    },
  },
}));

const ContainerWrapper = (props) => {
  const { width } = useViewport();
  const { children } = props;
  const classes = useStyle();
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState(
    getLocalStorage("pinSideDrawer") == "true" ? true : false
  );
  const [titleApp, setTitleApp] = useState("Dashboard");
  const [subTitleApp, setSubTitleApp] = useState("");
  useEffect(() => {
    if (getLocalStorage("pinSideDrawer")) {
      setPin(getLocalStorage("pinSideDrawer") == "true" ? true : false);
      if (getLocalStorage("pinSideDrawer") == "true") {
        setOpen(true);
      }
    }
  }, []);

  // Opens the dialog only when state is true
  useEffect(() => {
    if (props.showDialog) {
      props.setShowDialog(true)
    }
  }, [props.showDialog]);

  return (
    <>
      {showWebScreen(width) ? (
        <Grid className={classes.rsContainerWrapperRoot}>
          <Header
            pin={pin}
            setPin={setPin}
            open={open}
            setOpen={setOpen}
            titleApp={titleApp}
            setTitleApp={setTitleApp}
            subTitleApp={subTitleApp}
            setSubTitleApp={setSubTitleApp}
          />
          <SideDrawer
            open={open}
            setOpen={setOpen}
            pin={pin}
            setPin={setPin}
            welcomeDialog={props.welcomeDialog}
            setWelcomeDialog={props.setWelcomeDialog}
          />
          <Grid
            className={
              pin
                ? classes.rsContainerWrapperBody
                : classes.rsContainerWrapperBodyPin
            }
          >
            {titleApp !== "Settings" && titleApp !== "Dashboard" && (
              <Box className={classes.rsMainTitle}>
                <Typography
                  variant="h3"
                  medium
                  className="RsTitle"
                  color={"black"}
                >
                  {titleApp === "Create RX"
                    ? "Create Patient"
                    : titleApp === "Edit RX"
                    ? "Edit Patient"
                    : titleApp}
                </Typography>
                {subTitleApp ? (
                  <Typography
                    variant="body2"
                    className="RsSubTitle"
                  >
                    {subTitleApp}
                  </Typography>
                ) : null}
              </Box>
            )}
            <Box className="RsDashboardSpacing">{children}</Box>
          </Grid>
          {/*  First Login Welcome Dialog  */}
          {props.welcomeDialog && (
            <WelcomeDialog
              open={props.welcomeDialog}
              setOpen={props.setWelcomeDialog}
            />
          )}
          {props.showDialog && (
            <TimerLogoutDailog
              open={props.showDialog}
              setOpen={props.setShowDialog}
              remainingTime={props.remainingTime}
              triggerIdleAcrossTabs={props.triggerIdleAcrossTabs}
            />
          )}
        </Grid>
      ) : (
        <Grid className={classes.rsContainerWrapperRoot}>
          {console.log("welcomeDialog", props.welcomeDialog)}
          <HeaderMob
            welcomeDialog={props.welcomeDialog}
            setWelcomeDialog={props.setWelcomeDialog}
            titleApp={titleApp}
            setTitleApp={setTitleApp}
            subTitleApp={subTitleApp}
            setSubTitleApp={setSubTitleApp}
          />
          {props.welcomeDialog && (
            <WelcomeDialog
              open={props.welcomeDialog}
              setOpen={props.setWelcomeDialog}
            />
          )}
          {props.showDialog && (
            <TimerLogoutDailog
              open={props.showDialog}
              setOpen={props.setShowDialog}
              remainingTime={props.remainingTime}
              triggerIdleAcrossTabs={props.triggerIdleAcrossTabs}
            />
          )}
          {children}
        </Grid>
      )}
    </>
  );
};

export default ContainerWrapper;
